import $ from "jquery"; // jQuery is needed for datables
import "../lib/dataTables.foundation.min";

$(() => {
    function getOptionData($el) {
        //Change active state of Super and income stream button.

        console.log("REACHED GET OPTION DATA");
        $(".js-option").removeClass("is-active");
        $el.addClass("is-active");
        //Save the income component type value.
        $(".PerformanceData").hide();
        ComponentTypeSelected = $el.attr("pos");
        $(".PerformanceChartInput_" + ComponentTypeSelected).show(
            0,
            function () {
                tableFixedColumn();
            }
        );
        $("#download-investments-performance").data(
            "invttype",
            ComponentTypeSelected
        );

        var downloadUrl = $("#download-investments-performance").data("url");
        downloadUrl += "?ID=" + ComponentTypeSelected;
        $("#download-investments-performance").attr("href", downloadUrl);
        $("#download-financial-performance").data(
            "invttype",
            ComponentTypeSelected
        );

        var downloadUrl = $("#download-financial-performance").data("url");
        downloadUrl += "?ID=" + ComponentTypeSelected;
        $("#download-financial-performance").attr("href", downloadUrl);
        $("#download_monthly_returns").data("invttype", ComponentTypeSelected);

        var downloadUrl = $("#download_monthly_returns").data("url");
        downloadUrl += "?ID=" + ComponentTypeSelected;
        $("#download_monthly_returns").attr("href", downloadUrl);
        $("#download_monthly_returns_history").data(
            "invttype",
            ComponentTypeSelected
        );

        var downloadUrl = $("#download_monthly_returns_history").data("url");
        downloadUrl += "?ID=" + ComponentTypeSelected;
        $("#download_monthly_returns_history").attr("href", downloadUrl);
        $("#download_monthly_income").data("invttype", ComponentTypeSelected);

        var downloadUrl = $("#download_monthly_income").data("url");
        downloadUrl += "?ID=" + ComponentTypeSelected;
        $("#download_monthly_income").attr("href", downloadUrl);
        $("#download_monthly_income_history").data(
            "invttype",
            ComponentTypeSelected
        );

        var downloadUrl = $("#download_monthly_income_history").data("url");
        downloadUrl += "?ID=" + ComponentTypeSelected;
        $("#download_monthly_income_history").attr("href", downloadUrl);
        $("#download_weekly_returns").data("invttype", ComponentTypeSelected);

        var downloadUrl = $("#download_weekly_returns").data("url");
        downloadUrl += "?ID=" + ComponentTypeSelected;
        $("#download_weekly_returns").attr("href", downloadUrl);
        $("#download_weekly_returns_history").data(
            "invttype",
            ComponentTypeSelected
        );

        var downloadUrl = $("#download_weekly_returns_history").data("url");
        downloadUrl += "?ID=" + ComponentTypeSelected;
        $("#download_weekly_returns_history").attr("href", downloadUrl);
        $("#download_weekly_income").data("invttype", ComponentTypeSelected);

        var downloadUrl = $("#download_weekly_income").data("url");
        downloadUrl += "?ID=" + ComponentTypeSelected;
        $("#download_weekly_income").attr("href", downloadUrl);
        $("#download_weekly_income_history").data(
            "invttype",
            ComponentTypeSelected
        );

        var downloadUrl = $("#download_weekly_income_history").data("url");
        downloadUrl += "?ID=" + ComponentTypeSelected;
        $("#download_weekly_income_history").attr("href", downloadUrl);
    }
    function getOptionParameterValue() {
        const queryString = window.location.search,
            regex = new RegExp("[?&]option(=([^&#]*)|&|#|$)"), // Create a regular expression to find the parameter and its value
            results = regex.exec(queryString);
        if (results && results[2]) {
            // If the parameter is found, return its value; otherwise, return null
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }
        return null;
    }
    const acceptedOptionValues = ["super", "ttr", "retirement"],
        mappedButtonIds = ["btn-1", "btn-2", "btn-3"],
        optionParameterValue = getOptionParameterValue();
    if (acceptedOptionValues.includes(optionParameterValue)) {
        const selectedIndex =
                acceptedOptionValues.indexOf(optionParameterValue),
            selectedButtonId = mappedButtonIds[selectedIndex],
            $selectedButtonOption = $(`#${selectedButtonId}`);
        setTimeout(() => {
            // need this timeout as it was not reloading the second table correctly on the weekly returns template
            $selectedButtonOption.trigger("click");
            getOptionData($selectedButtonOption);
            console.log("Reached matched param after 1s", {
                optionParameterValue,
                selectedButtonId,
                $selectedButtonOption,
            }); //ToDo: remove this before going live
        }, 1000);
    }

    let ComponentTypeSelected = $(".js-option.is-active").attr("pos");
    $("th").css({ fontWeight: 400 });

    $(".js-option").on("click", function () {
        getOptionData($(this));
    });
    // Wraps the table with responsive div
    $(".table-rates").wrap('<div class="responsive"></div>');
    // Double wraps the fixed column table
    $(".js-fixed-column")
        .parent()
        .wrap('<div class="responsive-table-wrapper"></div>');
    // Responsive Table Fixed column
    // Checks for table-stackable class on the table
    // Sets the row height to be the same as the first item
    function tableFixedColumn() {
        $(".js-fixed-column tbody").each(function () {
            $("tr", this).each(function () {
                let maxCellHeight = 0;
                const tds = $("td", this);
                tds.each(function () {
                    const h = $(this).outerHeight();
                    maxCellHeight = h > maxCellHeight ? h : maxCellHeight;
                });
                //apply max height to all cells in row..
                tds.css("height", maxCellHeight);
            });
        });
    }
    tableFixedColumn();
    $("colgroup col").css({ minWidth: 0, maxWidth: 0 });

    $(window).on("load resize orientationchange", function () {
        tableFixedColumn();
        setTimeout(() => {
            $(".js-paginatedTableSplits colgroup col").css({ width: 0 });
        }, 200);
    });
});
